"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const ApiData_1 = __importDefault(require("./class/ApiData"));
const mainApi = {
    login: new ApiData_1.default({
        name: '登录',
        url: 'web/user/login',
        token: false,
        urlConfig: {
            pre: '',
            service: 'ufo/cs/'
        },
        method: 'post',
        data: ['inherit']
    }),
    refreshInfo: new ApiData_1.default({
        name: '获取用户信息',
        url: 'web/user/getByToken',
        token: true,
        urlConfig: {
            pre: '',
            service: 'ufo/cs/'
        },
        method: 'get',
        data: ['inherit']
    }),
    refreshCaptcha: new ApiData_1.default({
        name: '刷新验证码',
        url: 'web/user/captcha/',
        token: false,
        urlConfig: {
            pre: '',
            service: 'ufo/cs/'
        },
        method: 'get',
        data: ['url']
    }),
    refreshToken: new ApiData_1.default({
        name: '刷新Token',
        url: 'common/user/user/refresh_token',
        token: true,
        urlConfig: {
            pre: '',
            service: ''
        },
        method: 'get',
        data: ['inherit']
    })
};
exports.default = mainApi;
